import { Component } from '@angular/core';
import { WebapiService } from 'src/app/shared/services/webapi.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

  constructor(public webApi: WebapiService) {
  }
}
